import { render, staticRenderFns } from "./ParcelshopCard.vue?vue&type=template&id=920584f4&scoped=true"
import script from "./ParcelshopCard.vue?vue&type=script&lang=js"
export * from "./ParcelshopCard.vue?vue&type=script&lang=js"
import style0 from "./ParcelshopCard.vue?vue&type=style&index=0&id=920584f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920584f4",
  null
  
)

export default component.exports